import SetPageAnalyticsProps from 'components/Analytics/SetPageAnalyticsProps/SetPageAnalyticsProps';

export default SetPageAnalyticsProps;
